import React from 'react'
import {useSelector} from 'react-redux'
import { Container } from 'semantic-ui-react'
import {withRouter} from 'react-router-dom'
import RegistroEmail from '../LoginEmail/RegistroEmail'

const Login = (props) => {
    const activo = useSelector(store => store.usuario.activo)
    //console.log(activo)

    React.useEffect(() => {
        // console.log(activo)
        if(activo){
            props.history.push('/mi-cuenta')
        }else{ props.history.push('/registro')}
    }, [activo])

    return (
        <Container className='bodyFroms' id="bodyFroms">
        <div className="mt-5 text-center">
        </div>
        <RegistroEmail/>    
        </Container> 
    )
}




export default withRouter(Login)
